var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-form" },
    [
      _c(
        "el-form",
        { attrs: { model: _vm.form, "label-width": "70px" } },
        [
          _c("el-form-item", { attrs: { label: "展示logo" } }, [
            _c(
              "div",
              { staticClass: "logo" },
              [
                _c("el-checkbox", {
                  model: {
                    value: _vm.form.isLogo,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "isLogo", $$v)
                    },
                    expression: "form.isLogo",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "logo-img",
                    on: {
                      click: function ($event) {
                        return _vm.uploadbgImg("logoUrl")
                      },
                    },
                  },
                  [
                    _vm.form.logoUrl
                      ? _c("img", { attrs: { src: _vm.form.logoUrl } })
                      : _c("i", {
                          staticClass: "el-icon-camera cameraIconfont",
                        }),
                  ]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "提示文字" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入提示文字" },
                model: {
                  value: _vm.form.searchDefault,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "searchDefault", $$v)
                  },
                  expression: "form.searchDefault",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "文本位置" } },
            [
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.form.searchType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "searchType", $$v)
                    },
                    expression: "form.searchType",
                  },
                },
                _vm._l(_vm.placeholderPositionEnum, function (rad) {
                  return _c(
                    "el-radio",
                    { key: rad.value, attrs: { label: rad.value } },
                    [_vm._v(_vm._s(rad.label))]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-divider"),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("span", [_vm._v("边距：")]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "左侧" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.form.searchPadding.pl,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.searchPadding, "pl", $$v)
                      },
                      expression: "form.searchPadding.pl",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "顶侧" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.form.searchPadding.pt,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.searchPadding, "pt", $$v)
                      },
                      expression: "form.searchPadding.pt",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "右侧" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.form.searchPadding.pr,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.searchPadding, "pr", $$v)
                      },
                      expression: "form.searchPadding.pr",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "底侧" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0 },
                    model: {
                      value: _vm.form.searchPadding.pb,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.searchPadding, "pb", $$v)
                      },
                      expression: "form.searchPadding.pb",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }